"use client";

import { c as _c } from "react/compiler-runtime";
import { LabelInput } from "@/shared/ui/molecules";
import { TextButton } from "@/shared/ui/atoms";
import { Loading } from "@/shared/ui/organisms";
import useUIStore from "@/shared/stores/ui/store";
import { validatePhone } from "@/shared/utils/validation";
import { useMutationPostUnrestrictedInquiry } from "@/entities/user/hooks/useUser";
import useInquiryLandingStore from "@/features/inquiry-landing/model/store";
const ApplyForm = () => {
  const $ = _c(40);
  const {
    hospitalName,
    userName,
    phone,
    setHospitalName,
    setUserName,
    setPhone,
    reset
  } = useInquiryLandingStore();
  const {
    showToast
  } = useUIStore();
  let t0;
  if ($[0] !== reset || $[1] !== showToast) {
    t0 = () => {
      reset();
      showToast("success", "\uC0C1\uB2F4 \uC2E0\uCCAD\uC774 \uC644\uB8CC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
    };
    $[0] = reset;
    $[1] = showToast;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== showToast) {
    t1 = () => {
      showToast("error", "\uC0C1\uB2F4 \uC2E0\uCCAD\uC5D0 \uC2E4\uD328\uD588\uC2B5\uB2C8\uB2E4.");
    };
    $[3] = showToast;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== t0 || $[6] !== t1) {
    t2 = {
      onSuccess: t0,
      onError: t1
    };
    $[5] = t0;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const {
    mutate: postInquiry,
    isPending
  } = useMutationPostUnrestrictedInquiry(t2);
  let t3;
  if ($[8] !== hospitalName || $[9] !== phone || $[10] !== postInquiry || $[11] !== showToast || $[12] !== userName) {
    t3 = () => {
      if (!hospitalName) {
        return showToast("error", "\uBCD1\uC6D0\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
      }
      if (!userName) {
        return showToast("error", "\uB2F4\uB2F9\uC790\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694.");
      }
      if (!phone) {
        return showToast("error", "\uC5F0\uB77D\uCC98\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694.");
      }
      if (phone.includes("-")) {
        return showToast("error", "\uC5F0\uB77D\uCC98\uC5D0 '-'\uC744 \uC81C\uAC70\uD574\uC8FC\uC138\uC694.");
      }
      if (!validatePhone(phone)) {
        return showToast("error", "\uC5F0\uB77D\uCC98 \uD615\uC2DD\uC774 \uC62C\uBC14\uB974\uC9C0 \uC54A\uC2B5\uB2C8\uB2E4.");
      }
      postInquiry({
        hospitalName,
        userName,
        phone
      });
    };
    $[8] = hospitalName;
    $[9] = phone;
    $[10] = postInquiry;
    $[11] = showToast;
    $[12] = userName;
    $[13] = t3;
  } else {
    t3 = $[13];
  }
  const submit = t3;
  let t4;
  if ($[14] !== isPending) {
    t4 = isPending && <Loading />;
    $[14] = isPending;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== setHospitalName) {
    t5 = e_0 => setHospitalName(e_0.target.value);
    $[16] = setHospitalName;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] !== hospitalName || $[19] !== t5) {
    t6 = <LabelInput type="text" label={"\uBCD1\uC6D0\uBA85"} placeholder={"\uC18C\uC18D \uBCD1\uC6D0\uBA85\uC744 \uC785\uB825\uD574\uC8FC\uC138\uC694."} value={hospitalName} onChange={t5} />;
    $[18] = hospitalName;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== setUserName) {
    t7 = e_1 => setUserName(e_1.target.value);
    $[21] = setUserName;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t7 || $[24] !== userName) {
    t8 = <LabelInput type="text" label={"\uB2F4\uB2F9\uC790\uBA85"} placeholder={"\uAE40\uC9C4\uC544(\uC6D0\uC7A5)"} value={userName} onChange={t7} />;
    $[23] = t7;
    $[24] = userName;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== setPhone) {
    t9 = e_2 => setPhone(e_2.target.value);
    $[26] = setPhone;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  let t10;
  if ($[28] !== phone || $[29] !== t9) {
    t10 = <LabelInput type="text" label={"\uC5F0\uB77D\uCC98"} placeholder={"'-' \uC81C\uC678\uD558\uACE0 \uC22B\uC790\uB9CC \uC785\uB825\uD574\uC8FC\uC138\uC694."} value={phone} onChange={t9} />;
    $[28] = phone;
    $[29] = t9;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== isPending || $[32] !== submit) {
    t11 = <TextButton text={"1\uAC1C\uC6D4 \uBB34\uB8CC \uC0C1\uB2F4 \uC2E0\uCCAD\uD558\uAE30 \u2192"} className="mt-2 w-full break-keep rounded-full bg-primary-600 py-4 text-[18px] font-semibold text-white transition-opacity hover:opacity-90 disabled:cursor-not-allowed disabled:bg-[#F7F7F7] disabled:text-[#989BA2]" onClick={submit} disabled={isPending} />;
    $[31] = isPending;
    $[32] = submit;
    $[33] = t11;
  } else {
    t11 = $[33];
  }
  let t12;
  if ($[34] !== t10 || $[35] !== t11 || $[36] !== t4 || $[37] !== t6 || $[38] !== t8) {
    t12 = <form className="flex flex-col gap-4" onSubmit={_temp}>{t4}{t6}{t8}{t10}{t11}</form>;
    $[34] = t10;
    $[35] = t11;
    $[36] = t4;
    $[37] = t6;
    $[38] = t8;
    $[39] = t12;
  } else {
    t12 = $[39];
  }
  return t12;
};
export default ApplyForm;
function _temp(e) {
  return e.preventDefault();
}